/**
 * Sprint date calculation utilities shared between WorkstreamForm and SprintPlanningView.
 */

/** Add the given number of business days (Mon-Fri) to a date. */
export const addBusinessDays = (date: Date, days: number): Date => {
  const result = new Date(date);
  let added = 0;
  while (added < days) {
    result.setDate(result.getDate() + 1);
    const dow = result.getDay();
    if (dow !== 0 && dow !== 6) added++;
  }
  return result;
};

/** Format a date as "Mon D" (e.g. "Apr 7"). */
export const formatDate = (d: Date): string =>
  d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });

/**
 * Returns the start and end dates for sprint number `sprintNumber` (1-based),
 * given the timeline's ISO start date and sprint length in business days.
 */
export const getSprintDateRange = (
  startDateIso: string,
  sprintLength: number,
  sprintNumber: number,
): { start: Date; end: Date } => {
  let current = new Date(startDateIso);
  for (let i = 0; i < sprintNumber - 1; i++) {
    current = addBusinessDays(current, sprintLength);
  }
  const end = addBusinessDays(current, sprintLength - 1);
  return { start: current, end };
};
